// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet crm-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { CollectionResultOfCrmUbosGetUbosByRelatieDto } from '../model/collectionResultOfCrmUbosGetUbosByRelatieDto';

import type { CrmDomainDomainUbosUboContext } from '../model/crmDomainDomainUbosUboContext';

import type { CrmUbosForceerUboResultaatForceerUboDto } from '../model/crmUbosForceerUboResultaatForceerUboDto';

import type { CrmUbosUboDto } from '../model/crmUbosUboDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboInzien</li></ul>
 * @summary Haal de UBO's van een relatie op.
 */
export const uboGet = (
  relatieId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatieId = unref(relatieId);

  return customInstance<CollectionResultOfCrmUbosGetUbosByRelatieDto>(
    { url: `/api/v1/relaties/${relatieId}/ubo`, method: 'GET', signal },
    options,
  );
};

export const getUboGetQueryKey = (relatieId: MaybeRef<string | undefined | null>) => {
  return ['api', 'v1', 'relaties', relatieId, 'ubo'] as const;
};

export const getUboGetQueryOptions = <
  TData = Awaited<ReturnType<typeof uboGet>>,
  TError = ErrorType<void>,
>(
  relatieId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof uboGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getUboGetQueryKey(relatieId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof uboGet>>> = ({ signal }) =>
    uboGet(relatieId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(relatieId) !== null && unref(relatieId) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof uboGet>>, TError, TData>;
};

export type UboGetQueryResult = NonNullable<Awaited<ReturnType<typeof uboGet>>>;
export type UboGetQueryError = ErrorType<void>;

/**
 * @summary Haal de UBO's van een relatie op.
 */

export function useUboGet<TData = Awaited<ReturnType<typeof uboGet>>, TError = ErrorType<void>>(
  relatieId: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof uboGet>>, TError, TData>>;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUboGetQueryOptions(relatieId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboAanmaken</li></ul>
 * @summary Maak een nieuwe UBO aan.
 */
export const uboCreate = (
  relatieId: MaybeRef<string | undefined | null>,
  crmUbosUboDto?: MaybeRef<CrmUbosUboDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatieId = unref(relatieId);
  crmUbosUboDto = unref(crmUbosUboDto);

  return customInstance<string>(
    {
      url: `/api/v1/relaties/${relatieId}/ubo`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmUbosUboDto,
      signal,
    },
    options,
  );
};

export const getUboCreateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboCreate>>,
    TError,
    { relatieId: string | undefined | null; data?: CrmUbosUboDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboCreate>>,
  TError,
  { relatieId: string | undefined | null; data?: CrmUbosUboDto },
  TContext
> => {
  const mutationKey = ['uboCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboCreate>>,
    { relatieId: string | undefined | null; data?: CrmUbosUboDto }
  > = (props) => {
    const { relatieId, data } = props ?? {};

    return uboCreate(relatieId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboCreateMutationResult = NonNullable<Awaited<ReturnType<typeof uboCreate>>>;
export type UboCreateMutationBody = CrmUbosUboDto | undefined;
export type UboCreateMutationError = ErrorType<void>;

/**
 * @summary Maak een nieuwe UBO aan.
 */
export const useUboCreate = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboCreate>>,
      TError,
      { relatieId: string | undefined | null; data?: CrmUbosUboDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboCreate>>,
  TError,
  { relatieId: string | undefined | null; data?: CrmUbosUboDto },
  TContext
> => {
  return useMutation(getUboCreateMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboBijwerken</li></ul>
 * @summary Werkt een bestaande UBO bij.
 */
export const uboUpdate = (
  uboId: MaybeRef<string | undefined | null>,
  crmUbosUboDto?: MaybeRef<CrmUbosUboDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = unref(uboId);
  crmUbosUboDto = unref(crmUbosUboDto);

  return customInstance<void>(
    {
      url: `/api/v1/ubo/${uboId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmUbosUboDto,
      signal,
    },
    options,
  );
};

export const getUboUpdateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboUpdate>>,
    TError,
    { uboId: string | undefined | null; data?: CrmUbosUboDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboUpdate>>,
  TError,
  { uboId: string | undefined | null; data?: CrmUbosUboDto },
  TContext
> => {
  const mutationKey = ['uboUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboUpdate>>,
    { uboId: string | undefined | null; data?: CrmUbosUboDto }
  > = (props) => {
    const { uboId, data } = props ?? {};

    return uboUpdate(uboId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof uboUpdate>>>;
export type UboUpdateMutationBody = CrmUbosUboDto | undefined;
export type UboUpdateMutationError = ErrorType<void>;

/**
 * @summary Werkt een bestaande UBO bij.
 */
export const useUboUpdate = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboUpdate>>,
      TError,
      { uboId: string | undefined | null; data?: CrmUbosUboDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboUpdate>>,
  TError,
  { uboId: string | undefined | null; data?: CrmUbosUboDto },
  TContext
> => {
  return useMutation(getUboUpdateMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboVerwijderen</li></ul>
 * @summary Verwijder een UBO.
 */
export const uboDelete = (
  uboId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = unref(uboId);

  return customInstance<void>({ url: `/api/v1/ubo/${uboId}`, method: 'DELETE', signal }, options);
};

export const getUboDeleteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboDelete>>,
    TError,
    { uboId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboDelete>>,
  TError,
  { uboId: string | undefined | null },
  TContext
> => {
  const mutationKey = ['uboDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboDelete>>,
    { uboId: string | undefined | null }
  > = (props) => {
    const { uboId } = props ?? {};

    return uboDelete(uboId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof uboDelete>>>;

export type UboDeleteMutationError = ErrorType<void>;

/**
 * @summary Verwijder een UBO.
 */
export const useUboDelete = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboDelete>>,
      TError,
      { uboId: string | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboDelete>>,
  TError,
  { uboId: string | undefined | null },
  TContext
> => {
  return useMutation(getUboDeleteMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboCheck</li></ul>
 * @summary Voer UBO check uit.
 */
export const uboCheck = (
  uboId: MaybeRef<string | undefined | null>,
  crmDomainDomainUbosUboContext?: MaybeRef<CrmDomainDomainUbosUboContext>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = unref(uboId);
  crmDomainDomainUbosUboContext = unref(crmDomainDomainUbosUboContext);

  return customInstance<void>(
    {
      url: `/api/v1/ubo/${uboId}/check`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmDomainDomainUbosUboContext,
      signal,
    },
    options,
  );
};

export const getUboCheckMutationOptions = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboCheck>>,
    TError,
    { uboId: string | undefined | null; data?: CrmDomainDomainUbosUboContext },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboCheck>>,
  TError,
  { uboId: string | undefined | null; data?: CrmDomainDomainUbosUboContext },
  TContext
> => {
  const mutationKey = ['uboCheck'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboCheck>>,
    { uboId: string | undefined | null; data?: CrmDomainDomainUbosUboContext }
  > = (props) => {
    const { uboId, data } = props ?? {};

    return uboCheck(uboId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboCheckMutationResult = NonNullable<Awaited<ReturnType<typeof uboCheck>>>;
export type UboCheckMutationBody = CrmDomainDomainUbosUboContext | undefined;
export type UboCheckMutationError = ErrorType<void>;

/**
 * @summary Voer UBO check uit.
 */
export const useUboCheck = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboCheck>>,
      TError,
      { uboId: string | undefined | null; data?: CrmDomainDomainUbosUboContext },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboCheck>>,
  TError,
  { uboId: string | undefined | null; data?: CrmDomainDomainUbosUboContext },
  TContext
> => {
  return useMutation(getUboCheckMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Crm.UboResultaatOverschrijven</li></ul>
 * @summary Forceer UBO resultaat als compliance medewerker.
 */
export const uboForceerResultaat = (
  uboId: MaybeRef<string | undefined | null>,
  crmUbosForceerUboResultaatForceerUboDto?: MaybeRef<CrmUbosForceerUboResultaatForceerUboDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  uboId = unref(uboId);
  crmUbosForceerUboResultaatForceerUboDto = unref(crmUbosForceerUboResultaatForceerUboDto);

  return customInstance<void>(
    {
      url: `/api/v1/ubo/${uboId}/forceer-resultaat`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: crmUbosForceerUboResultaatForceerUboDto,
      signal,
    },
    options,
  );
};

export const getUboForceerResultaatMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uboForceerResultaat>>,
    TError,
    { uboId: string | undefined | null; data?: CrmUbosForceerUboResultaatForceerUboDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uboForceerResultaat>>,
  TError,
  { uboId: string | undefined | null; data?: CrmUbosForceerUboResultaatForceerUboDto },
  TContext
> => {
  const mutationKey = ['uboForceerResultaat'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uboForceerResultaat>>,
    { uboId: string | undefined | null; data?: CrmUbosForceerUboResultaatForceerUboDto }
  > = (props) => {
    const { uboId, data } = props ?? {};

    return uboForceerResultaat(uboId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UboForceerResultaatMutationResult = NonNullable<
  Awaited<ReturnType<typeof uboForceerResultaat>>
>;
export type UboForceerResultaatMutationBody = CrmUbosForceerUboResultaatForceerUboDto | undefined;
export type UboForceerResultaatMutationError = ErrorType<void>;

/**
 * @summary Forceer UBO resultaat als compliance medewerker.
 */
export const useUboForceerResultaat = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uboForceerResultaat>>,
      TError,
      { uboId: string | undefined | null; data?: CrmUbosForceerUboResultaatForceerUboDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof uboForceerResultaat>>,
  TError,
  { uboId: string | undefined | null; data?: CrmUbosForceerUboResultaatForceerUboDto },
  TContext
> => {
  return useMutation(getUboForceerResultaatMutationOptions(options), queryClient);
};
